// import { v4 as uuid } from 'uuid'

const getInitialState = () => ({
  history_sessions: [],
  history_hands: [],
})
const state = getInitialState()

const getters = {
  history_sessions: state => state.history_sessions,
  history_hands: state => state.history_hands,
  // history_list: (state) => {
  // let res = [...state.history_hands, ...state.history_sessions]
  // res = res.sort((a, b) => (a.created_at > b.created_at ? -1 : 1))
  // return res
  // },
}

const actions = {
  history_add_hand({ state, commit, dispatch, getters, rootGetters }, { hand }) {
    let hands = state.history_hands

    if (hands.length > 1000) {
      // if (hands.length > 0) {
      const lastHand = hands.pop()
      const handSession = state.history_sessions.find(i => i.uid === lastHand.session_uid)
      handSession.incomplete = true
      dispatch('history_update_session', { session: handSession })
    }

    const handStringified = {
      created_at: hand.created_at,
      session_uid: hand.session_uid,
      uid: hand.uid,
      marked: hand.marked,
      avg_gto_score: hand.stats_hand.avg_gto_score,
      stringified_hand: JSON.stringify(hand),
    }

    hands = [...state.history_hands, handStringified]
    commit(`history_set`, { key: 'history_hands', value: hands })
  },
  history_update_session({ state, commit, dispatch, getters, rootGetters }, { session }) {
    let sessions = state.history_sessions
    const idx = state.history_sessions.findIndex(i => i.uid === session.uid)
    if (idx === -1) {
      sessions = [...sessions, session]
    } else {
      sessions[idx] = {
        ...sessions[idx],
        ...session,
      }
    }
    // console.log(sessions)
    commit(`history_set`, { key: 'history_sessions', value: sessions })
  },
  history_update_hand({ state, commit, dispatch, getters, rootGetters }, { hand }) {
    let hands = state.history_hands
    const idx = state.history_hands.findIndex(i => i.uid === hand.uid)
    if (idx !== -1) {
      // hands[idx] = hand // this way does not trigger vuex reactivity
      hands = hands.map((hh, hIdx) => (idx === hIdx ? hand : hh))
      commit(`history_set`, { key: 'history_hands', value: hands })
    }
  },
}
const mutations = {
  history_reset(state, initialState = getInitialState()) {
    Object.assign(state, initialState)
  },
  history_set(state, { key, value }) {
    state[key] = value
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
